import React from 'react';

import { MoodMeterUser, useGetMoodmeterNameUsersGroupMoodQuery } from '../MoodMeterSlice';
import './UsersMood.css';

export type UsersMoodProps = {
    empId: string;
    moodType: string | undefined;
    managerdisplay: string;
};

const UsersMood = ({ empId, moodType, managerdisplay }: UsersMoodProps) => {
    const { data: userMoodType, isLoading } = useGetMoodmeterNameUsersGroupMoodQuery(
        {
            supervisorNumber: empId,
            moodType,
            filter: managerdisplay,
        },
        { skip: !empId || !moodType || !managerdisplay }
    );

    if (isLoading) return <div className="loadingUser"> Loading...</div>;

    return (
        <table>
            <tbody>
                {userMoodType?.data?.map((user: MoodMeterUser) => (
                    <tr key={user.employee_number}>
                        <td>
                            <span className="icon-tooltip-text">
                                {user.first_name} {user.middle_name} {user.last_name}
                            </span>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default UsersMood;
